import { useEffect, useRef } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import { LoadingState } from "~/common/components";
import { isPatientActive } from "~/common/utils";
import { PaymentFinalMessage } from "~/patients/components";
import {
  useConfirmPayment,
  useGetCurrentPatient,
  useIntakeIntroScreenVisit,
} from "~/patients/hooks";
import { ROUTES } from "../router";

export const ConfirmPayment = () => {
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get("payment_intent");
  const { data: user, isFetching } = useGetCurrentPatient();
  const consultationId = user?.consultation?.id;
  const paymentConfirmationRef = useRef(false);

  const { intakeIntroScreenVisitMutation } = useIntakeIntroScreenVisit();

  const {
    mutate: confirmPaymentIntentMutation,
    isSuccess,
    isError,
    isPending,
  } = useConfirmPayment(intakeIntroScreenVisitMutation);

  useEffect(() => {
    if (consultationId && paymentId) {
      if (paymentConfirmationRef.current) return;
      paymentConfirmationRef.current = true;
      confirmPaymentIntentMutation({ paymentId, consultationId });
    }
  }, [paymentId, consultationId, confirmPaymentIntentMutation]);

  if (isFetching || isPending) return <LoadingState />;

  if (isPatientActive(user?.organization_patients[0].status))
    return <Navigate to={ROUTES.notFound} />;

  if (isSuccess || isError)
    return <PaymentFinalMessage paymentIntent={paymentId} isError={isError} />;

  return <LoadingState className="h-screen-calculated" />;
};
